function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import React, { useMemo } from 'react';
import { Segmentation } from 'common/types/reports/query';
import { ButtonSize } from 'common/components/button/constants';
import { SelectReact } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
// eslint-disable-next-line import/no-cycle
import { BucketPaneReact } from 'common/widgets/bucket-pane';
import { getBucketPreview } from 'common/widgets/bucket-pane/numeric-bucket-pane/util';
import { PropertyType, SPECIAL_EVENTS } from 'common/report/constants';
import { TimeUnitLabelTranslatable } from 'common/widgets/date-range-picker/models/types';
import { DURATION_UNIT_OPTION_SECTION_ITEMS, FUNNELS_TIME_TO_CONVERSION, PAGE_DURATION } from 'common/query-builder/query-block/properties-menu/constants';
import { useQueryContextManager } from 'common/contexts/react/query-context-manager';
import { useTranslation } from 'common/i18n/hooks';
import { ControlSelectEntryPoint, DefaultCustomBucket, DefaultCustomTCCBucket } from '../constants';
import { EntryRowProps } from '../row-types/types';
import { Action, EntryPart, isMetricEntry, isSegmentEntry, QueryBucketableEntry } from '../types';
import { getEntryPropertyType, openCustomBucket, usingNewBucketing } from '../row-types/row-util';
import { getCustomizeGroupsTrackingProps, QueryEntrySectionTrackingEvent } from '../tracking';
import { isMultiAttributionSegmentation } from '../row-types/behavior/utils';
export function CustomBucketSubitem(props: EntryRowProps<QueryBucketableEntry>) {
  const queryContextManager = useQueryContextManager();
  const {
    t,
    print
  } = useTranslation();
  const onMenuChange = (ev: CustomEvent) => {
    if (ev.detail.isOpen) {
      openCustomBucket(props, ControlSelectEntryPoint.CustomBucketSubItem);
    }
  };
  const onChange = (ev: CustomEvent) => {
    const currentCustomBucket = props.entry.customBucket;
    const newCustomBucket = ev.detail;
    props.updateEntry(Action.Edit, _objectSpread(_objectSpread({}, props.entry), {}, {
      customBucket: newCustomBucket
    }));
    props.setActivePart(EntryPart.CustomBucketing, "close");
    props.dispatchTrack(QueryEntrySectionTrackingEvent.ApplyCustomBucket, _objectSpread(_objectSpread({}, props.getEntryTrackingProps()), {}, {
      'Bucket min': newCustomBucket.min,
      'Bucket max': newCustomBucket.max,
      'Bucket size': newCustomBucket.bucketSize,
      'Is editing': !!currentCustomBucket
    }));
  };
  const onReset = () => {
    props.updateEntry(Action.Edit, _objectSpread(_objectSpread({}, props.entry), {}, {
      customBucket: null
    }));
    props.setActivePart(EntryPart.CustomBucketing, "close");
    props.dispatchTrack(QueryEntrySectionTrackingEvent.ResetCustomBucket, props.getEntryTrackingProps());
  };
  const onUpdateProperty = (ev: CustomEvent) => {
    const segment = ev.detail.segment;

    //TODO: Akshay (Customize Grouping) - add tracking event for updates on "apply" here - one event regardless of prop type (nums 3,4 on notion)
    props.dispatchTrack(QueryEntrySectionTrackingEvent.ApplyCustomBucket, _objectSpread(_objectSpread({}, getCustomizeGroupsTrackingProps(segment)), props.getEntryTrackingProps()));

    // For some reason customBucket can exist in both the event and outer section, so set them
    // to be the same. TODO make it only exist in the event
    props.updateEntry(Action.Edit, _objectSpread(_objectSpread({}, props.entry), {}, {
      event: segment,
      customBucket: segment.customBucket
    }));
  };
  const isOpen = props.activePart === EntryPart.CustomBucketing;
  const bucketLabel = useMemo(() => {
    var _props$entry, _props$entry$event2, _TimeUnitLabelTransla;
    if (!props.entry.event) return null;
    const bucket = (_props$entry = props.entry) === null || _props$entry === void 0 ? void 0 : _props$entry.customBucket;
    if (usingNewBucketing(props.entry)) {
      var _props$entry$event;
      // TODO(CC): get custom bucket text for metric entry
      if (isMetricEntry(props.entry)) {
        return null;
      }
      const type = getEntryPropertyType(props.entry);
      const simpleType = ((_props$entry$event = props.entry.event as Segmentation) === null || _props$entry$event === void 0 || (_props$entry$event = _props$entry$event.listItemGroup) === null || _props$entry$event === void 0 ? void 0 : _props$entry$event.propertyType) || type.type;
      let bucketText, valid;
      switch (simpleType) {
        case PropertyType.Number:
          valid = !!bucket;
          bucketText = isOpen ? t("query-builder.buckets.numeric-bucket") : valid && getBucketPreview(bucket);
          break;
        case PropertyType.String:
        case PropertyType.List:
        case PropertyType.Object:
          // TODO update if we ever want Objects to support other types
          valid = ((_props$entry$event2 = props.entry.event["customGroups"]) === null || _props$entry$event2 === void 0 ? void 0 : _props$entry$event2.length) > 0;

          // In theory the prop values could mess with the markdown but probably okay...
          // Looks like "Bucketing by **renamed; prop1, prop2; prop3**
          bucketText = isOpen ? t("query-builder.buckets.bucket-by") : valid && t("query-builder.buckets.bucket-by-groups", {
            groups: props.entry.event["customGroups"].map(group => {
              var _group$renamed;
              return (_group$renamed = group.renamed) !== null && _group$renamed !== void 0 ? _group$renamed : Array.isArray(group.filterValue) ? group.filterValue.join(", ") : group.filterValue;
            }).join(" | ")
          });
          break;
        case PropertyType.Datetime:
          valid = true;
          bucketText = t("query-builder.buckets.by-time-period", {
            timePeriod: print((_TimeUnitLabelTransla = TimeUnitLabelTranslatable[props.entry.event["unit"]]) === null || _TimeUnitLabelTransla === void 0 ? void 0 : _TimeUnitLabelTransla.call(TimeUnitLabelTranslatable, 1)) || "ISO 8601"
          });
          break;
        default:
          return null;
      }
      return isOpen || valid ? bucketText : null;
    } else if (bucket) {
      return "Custom bucket size **".concat(bucket.bucketSize, " between ").concat(bucket.min, "-").concat(bucket.max, "**");
    }
    return null;
  }, [props.entry, isOpen]);
  const bucketAttributes = useMemo(() => {
    var _props$entry2, _selectedBucket$unit;
    if (!props.entry.event) return {};
    const getDefaultBucket = (isTimeToConvert: boolean) => {
      var _queryContextManager$;
      const isSegmentSection = isSegmentEntry(props.entry);
      const defaultBucket = isSegmentSection && ((_queryContextManager$ = queryContextManager.segmentationMetadatas) === null || _queryContextManager$ === void 0 || (_queryContextManager$ = _queryContextManager$[props.index]) === null || _queryContextManager$ === void 0 ? void 0 : _queryContextManager$.numericBucket);
      if (isTimeToConvert) {
        return DefaultCustomTCCBucket;
      } else if (defaultBucket) {
        return defaultBucket;
      }
      return DefaultCustomBucket;
    };
    const bucket = (_props$entry2 = props.entry) === null || _props$entry2 === void 0 ? void 0 : _props$entry2.customBucket;
    if (isMetricEntry(props.entry)) {
      return {};
    }
    const customGroups = isSegmentEntry(props.entry) && (props.entry.event as Segmentation).customGroups;
    const isMultiAttribution = isSegmentEntry(props.entry) && isMultiAttributionSegmentation(props.entry.event);
    const isTimeToConvert = isSegmentEntry(props.entry) && ((props.entry.event as Segmentation).propertyName === FUNNELS_TIME_TO_CONVERSION.value || (props.entry.event as Segmentation).propertyName === PAGE_DURATION.value);
    const selectedBucket = bucket || getDefaultBucket(isTimeToConvert);
    const units = isTimeToConvert ? DURATION_UNIT_OPTION_SECTION_ITEMS : undefined;
    const selectedUnit = isTimeToConvert ? (_selectedBucket$unit = selectedBucket.unit) !== null && _selectedBucket$unit !== void 0 ? _selectedBucket$unit : "day" : "units"; //TODO - convert selected to display
    let eventNames = props.sectionProps.eventNames || [];
    // Multi attribution properties can come from potentially all event
    if (isMultiAttribution) {
      eventNames = eventNames.concat(SPECIAL_EVENTS.ALL_EVENTS);
    }
    return {
      eventNames,
      maxNumBuckets: 1000,
      resetBucket: !!bucket || !!customGroups,
      selectedBucket,
      selectedUnit,
      type: "units",
      header: "Customize Range",
      units,
      unitsAsProperty: isTimeToConvert
    };
  }, [props.index, props.entry, props.sectionProps.eventNames]);
  const bucketProps = usingNewBucketing(props.entry) && isSegmentEntry(props.entry) ? {
    segment: props.entry.event as Segmentation
  } : {};
  if (!props.hasNewUI) {
    return null;
  }
  return bucketLabel || isOpen ? <div className='subitem-text' data-sentry-component="CustomBucketSubitem" data-sentry-source-file="custom-bucket-subitem.tsx">
      <SelectReact className='subitem-select' label={bucketLabel || "Customize Buckets"} open={isOpen} theme={SelectTheme.QbSubitem} size={ButtonSize.Small} preventClose onMenuChange={onMenuChange} data-sentry-element="SelectReact" data-sentry-source-file="custom-bucket-subitem.tsx">
        <div slot='body'>
          {isOpen && <BucketPaneReact {...bucketAttributes} {...bucketProps} onClose={() => props.setActivePart(EntryPart.CustomBucketing, "close")} onUpdateSegment={onUpdateProperty} onChangeSelectedBucket={onChange} onResetBucket={onReset} />}
        </div>
      </SelectReact>
    </div> : null;
}